export enum Size {
	SMALL = "small",
	MEDIUM = "medium",
	LARGE = "large",
}
